/* global window document */
import $ from 'jquery'

if (!RedactorPlugins) var RedactorPlugins = {};
window.RedactorPlugins = RedactorPlugins;

RedactorPlugins.mergeField = {
  modalContent:
    '<section id="redactor-modal-merge-field-insert">'
    + '<em>Loading...</em>'
    + '</section>'
  + '<footer>'
					+ '<button class="redactor_modal_btn redactor_btn_modal_close">' + 'Cancel' + '</button>'
					+ '<button class="redactor_modal_btn redactor_modal_action_btn" id="redactor_insert_merge_field_btn">' + 'Insert' + '</button>'
				+ '</footer>',
  init: function () {
    var $redactor = this;
    this.buttonAdd('mergeField', 'Insert Merge Field', this.mergeFieldToolbarButtonClick);

    this.$editor.on("click", ".aa-merge-field", function () {
      $redactor.mergeFieldTooltip($(this));
      return false;
    });
    this.$editor.on("hover", ".aa-merge-field",
      function (e) {
        var $that = $(this);
        $that.toggleClass("ui-cursor-hand");
        if (e.type == "mouseenter") {
          $that.css("background-color", "#d0e5f5");
        }
        else { // mouseleave
          $that.removeAttr("style");
        }
      });

    $(document).on('click.redactor-mergeField-hide', $.proxy(this.mergeFieldTooltipHide, this));
    this.$editor.on('click.redactor-mergeField-hide', $.proxy(this.mergeFieldTooltipHide, this));
    $(document).on('keydown.redactor-mergeField-hide', $.proxy(this.mergeFieldTooltipHide, this));

  },
  mergeFieldToolbarButtonClick: function (buttonName, buttonDOM, buttonObj, e) {
    this.selectionSave();
    //modalInit: function(title, content, width, callback)
    this.modalInit("Insert Merge Field", this.modalContent, 320, $.proxy(function () {
      $('#redactor_insert_merge_field_btn').click($.proxy(this.mergeFieldInsert, this));
      $.ajax({
        type: "GET",
        url: "/Settings/OutreachTemplates/MergeFields",
        data: {
        },
        success: function (data) {
          $("#redactor-modal-merge-field-insert").html(data);
          $("option", "#MergeFields").dblclick(function () {
            $('#redactor_insert_merge_field_btn').click();
          });
        }
      });

    }, this));
  },
  mergeFieldInsert: function () {
    var key = $("#MergeFields").val();
    var displayText = $("#MergeFields option:selected").text();
    if (key != null) {
      var html = '<span contenteditable="false" class="aa-merge-field" data-merge-field-key="' + key + '">{{' + displayText + '}}</span>';
      this.bufferSet(false);

      var parent = this.getParent();
      if (parent && $(parent).hasClass("aa-merge-field")) {
        $(parent).remove();
      }

      this.selectionRestore();
      this.insertHtmlAdvanced(html, true);
    }
    this.modalClose();
  },
  mergeFieldTooltip: function ($mergeField) {
    var pos = $mergeField.offset();
    var tooltip = $('<span class="redactor-mergefield-tooltip"></span>');
    var aDelete = $('<a href="#">' + this.opts.curLang._delete + '</a>').on('click', $.proxy(function (e) {
      e.preventDefault();
      this.bufferSet(false);
      $mergeField.remove();
      this.sync();

    }, this));
    var aEdit = $('<a href="#">' + this.opts.curLang.edit + '</a>').on('click', $.proxy(this.mergeFieldToolbarButtonClick, this));
    tooltip.append(aDelete);
    tooltip.append(' | ');
    tooltip.append(aEdit);
    tooltip.css({
      top: (pos.top + 20) + 'px',
      left: pos.left + 'px'
    });
    $('.redactor-mergefield-tooltip').remove();
    $('body').append(tooltip);
  },
  mergeFieldTooltipHide: function () {
    $('.redactor-mergefield-tooltip').remove();
  }
};
